import React from 'react';

const Footer = () => {
    return (
        <div>
            <div class="row bg-light">
                <div class="col-md-12 copy">
                    <p class="text-center">&copy; Copyright {new Date().getFullYear()} - @shatabdiesh ---- All rights reserved.</p>
                </div>
            </div>

        </div>
    );
};

export default Footer;